/**
 * 本番環境用の空のDebugToolコンポーネント
 * WebpackのNormalModuleReplacementPluginにより、本番環境ではこのファイルが使用される
 */
import React from 'react';

export const DebugTool: React.FC = () => {
  return null;
};

// DebugToolからエクスポートされている定数も空の値を返す
export const DEBUG_PLAYBACK_RATE_KEY = 'debug-playback-rate';

export default DebugTool;

